/**
 * Favorites Mixin
 */

define(function(require, exports, module) {
    'use strict';
    var favoritesStore = require('stores/favorites/favorites.store.instance'),
        FavoritesModel = require('stores/favorites/favorites.model'),
        i18n = require('i18n');

    module.exports = {

        /**
         * Add to user favorites
         * @param {Object} attributes
         * @param {jBone} $favoritesBtn
         * @return {Deferred}
         */
        addToFavorites: function(attributes, $favoritesBtn) {
            var model = new FavoritesModel(attributes);

            if (favoritesStore.hasItem(attributes.favoriteID)) {
                return this._errorFavoritesAction({
                    data: {
                        errorMessage: this.translate('playtech.mobile.system.message.gameExistInFavorites')
                    }
                });
            }

            this._disableFavoritesBtn($favoritesBtn);
            model.save()
                .done(this._successAddToFavorites.bind(this, model, $favoritesBtn))
                .fail(this._errorFavoritesAction.bind(this))
                .always(this._enableFavoritesBtn.bind(this, $favoritesBtn));
        },

        /**
         * Remove from user favorites
         * @param {Number} favoriteID
         * @param {jBone} $favoritesBtn
         * @return {Deferred}
         */
        removeFromFavorites: function(favoriteID, $favoritesBtn) {
            var favorite = favoritesStore.getItem(favoriteID);

            if (favorite) {
                this._disableFavoritesBtn($favoritesBtn);
                favorite.destroy()
                    .done(this._successRemoveFromFavorites.bind(this, $favoritesBtn))
                    .fail(this._errorFavoritesAction.bind(this))
                    .always(this._enableFavoritesBtn.bind(this, $favoritesBtn));

                favoritesStore._collection.each(function(favor, index) {
                    favor.set('priority', ++index);
                });
            } else {
                return false;
            }
        },

        /**
         * Toggle favorite status (add/remove)
         * @param {Object} attributes
         * @param {jBone} $favoritesBtn
         */
        toggleFavorites: function(attributes, $favoritesBtn) {
            favoritesStore.hasItem(attributes.favoriteID)
                ? this.removeFromFavorites(attributes.favoriteID, $favoritesBtn)
                : this.addToFavorites(attributes, $favoritesBtn);
        },

        /**
         * Change priority of favorite item
         * @param  {Number} favoriteID  ID of favorite
         * @param  {Number} shift       move favorite by [shift] value
         * @return {Deferred}
         */
        changePriority: function(favoriteID, shift) {
            var favorite = favoritesStore.getItem(favoriteID);
            var priority = favorite.get('priority') - shift;

            if (favorite) {
                favoritesStore.changePriority(favorite, priority);
            }
        },

        _successAddToFavorites: function(model, $favoritesBtn) {
            console.log($favoritesBtn);
            $favoritesBtn && $favoritesBtn.addClass('active');

            favoritesStore.addItem(model);
            this.showInfo({
                content: this.translate('playtech.mobile.system.message.successAddToFavorites'),
                variant: this.toastVariants.SUCCESS
            });
        },

        _successRemoveFromFavorites: function($favoritesBtn) {
            $favoritesBtn && $favoritesBtn.removeClass('active');
            this.showInfo({
                content: this.translate('playtech.mobile.system.message.successRemoveFromFavorites'),
                variant: this.toastVariants.SUCCESS
            });
        },

        _disableFavoritesBtn: function($favoritesBtn) {
            $favoritesBtn && $favoritesBtn.addClass('disabled');
        },

        _enableFavoritesBtn: function($favoritesBtn) {
            $favoritesBtn && $favoritesBtn.removeClass('disabled');
        },

        _errorFavoritesAction: function(response) {
            this.showInfo({
                content: response.data.errorMessage || i18n.t('playtech.mobile.system.favorites.errorFavoritesAction'),
                variant: this.toastVariants.ERROR
            });
        }
    };
});
